import { createApp } from 'vue'

import 'virtual:windi.css'

import * as UI from 'element-plus'
import * as Icon from '@element-plus/icons'
import 'element-plus/theme-chalk/index.css'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import 'dayjs/locale/zh-cn'

import TeaConList from './components/TeaConList.vue'
import TeaConListItem from './components/TeaConListItem.vue'
import TeaConAvatar from './components/TeaConAvatar.vue'

import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(advancedFormat)

const components = [
  Icon.Management,
  UI.ElAvatar,
  UI.ElBacktop,
  UI.ElButton,
  UI.ElCarousel,
  UI.ElCarouselItem,
  UI.ElDescriptions,
  UI.ElDescriptionsItem,
  UI.ElDialog,
  UI.ElDropdown,
  UI.ElDropdownMenu,
  UI.ElDropdownItem,
  UI.ElEmpty,
  UI.ElForm,
  UI.ElFormItem,
  UI.ElIcon,
  UI.ElInput,
  UI.ElLoading,
  UI.ElPageHeader,
  UI.ElPagination,
  UI.ElPopper,
  UI.ElSteps,
  UI.ElStep,
  UI.ElTabs,
  UI.ElTabPane,
  UI.ElTooltip,
  UI.ElUpload,
  TeaConAvatar,
  TeaConList,
  TeaConListItem
]

const app = createApp(App)

components.forEach(component => {
  app.component(component.name, component)
})

app.use(UI.ElMessage)

app.use(router)
app.use(store)

app.config.globalProperties.$cookies = Cookies

app.mount('#app')
